(function() {
    $(document).on('click', '.js-toggle-comment-toggler', function() {
        var $scope = $(this).closest('.js-toggle-comment-scope');
        $($scope).toggleClass('toggled');
    });
})();
